import { createPopper } from '@popperjs/core';
import { isChromeIos } from '../../../helpers/browserCheck';

const TRANSITION_TIMEOUT_MS = 400;
const ENTER_DELAY_TIMEYOUT_MS = 100;


class Popup {
  constructor(tag, options = {}) {
    this.node = document.querySelector(`[data-uipopup-for="${tag}"]`);
    if (!this.node) return;
    this.overlay = document.querySelector(`[data-uipopup-overlay="${tag}"]`);
    this.trigger = document.querySelector(`[data-uipopup-trigger="${tag}"]`);
    this.triggers = [...document.querySelectorAll('[data-uipopup-trigger]')];
    this.closeButtons = [...this.node.querySelectorAll('[data-uipopup-close]')];
    this.options = options;
    this.opened = false;
    this.visibilityTimeout = null;

    this.triggerClassNameWhenPopupOpened = options.triggerClassNameWhenPopupOpened || '-active';
    this.closeOnTriggerClick =
      options.closeOnTriggerClick !== undefined ? options.closeOnTriggerClick : true;

    this.attachListeners();
  }

  popperState = ({ state }) => {
    if (this.options.disablePopperState) return;
    if (state.placement === 'top') {
      this.node.classList.remove('-bottom');
      this.node.classList.add('-top');
    } else if (state.placement === 'bottom') {
      this.node.classList.remove('-top');
      this.node.classList.add('-bottom');
    }
  };

  attachListeners() {
    if (this.options.disableTriggerClick) return;
    this.trigger.addEventListener('click', () => {
      if (this.opened && !this.closeOnTriggerClick) return;

      if (this.opened) {
        this.close();
      } else {
        this.open();
      }
    });

    createPopper(this.trigger, this.node, {
      modifiers: [
        {
          name: 'flipper',
          enabled: true,
          phase: 'main',
          fn: this.popperState,
        },
      ],
      ...(this.options.placement && { placement: this.options.placement }),
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        this.close();
      });
    });

    if (isChromeIos()) {
      this.node.classList.add('-no-transitions');
      this.overlay.classList.add('-no-transitions');
    }
  }

  outsideListener = (event) => {
    if (!this.opened || [this.node, this.trigger].some((el) => el.contains(event.target))) {
      return;
    }

    const isOtherPopupOpened = this.triggers.some((trigger) => trigger.contains(event.target));

    this.close(isOtherPopupOpened);
  };

  open = () => {
    const isFavortieButtonOrActive =
      this.trigger.dataset.favorites && this.trigger.classList.contains('-active');
    if (isFavortieButtonOrActive) return;
    clearTimeout(this.visibilityTimeout);
    this.opened = true;
    this.scrollPosition = window.pageYOffset;
    if (!this.options.disableTriggerClassNameChange) {
      this.trigger.classList.add(this.triggerClassNameWhenPopupOpened);
    }
    this.node.classList.add('-visible');
    this.overlay.classList.add('-visible');

    this.visibilityTimeout = setTimeout(() => {
      if (!this.opened) return;

      this.node.classList.add('-opened');
      this.overlay.classList.add('-opened');
    }, ENTER_DELAY_TIMEYOUT_MS);

    document.documentElement.style.setProperty('--scrollPosition', `-${this.scrollPosition}px`);
    document.body.classList.add('UIPopup-no-scroll');
    document.addEventListener('click', this.outsideListener);
    if (this.options.onOpen) this.options.onOpen();
  };

  close = (isOtherPopupOpened) => {
    if (!this.node) return;
    clearTimeout(this.visibilityTimeout);
    this.opened = false;
    if (!this.options.disableTriggerClassNameChange) {
      this.trigger.classList.remove(this.triggerClassNameWhenPopupOpened);
    }
    this.node.classList.remove('-opened');
    this.overlay.classList.remove('-opened');

    this.visibilityTimeout = setTimeout(() => {
      if (this.opened) return;

      this.node.classList.remove('-visible');
      this.overlay.classList.remove('-visible');
    }, TRANSITION_TIMEOUT_MS);

    if (!isOtherPopupOpened) {
      document.body.classList.remove('UIPopup-no-scroll');
    }
    if (!this.options.disableScrollToPosition) {
      window.scrollTo(0, this.scrollPosition);
    }
    document.removeEventListener('click', this.outsideListener);
    if (this.options.onClose) this.options.onClose();
  };
}

export default Popup;
